/** Public API base URL. Set REACT_APP_API_URL at build time (e.g. Docker build-arg). */
const origin =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : "";

// Default to same-origin proxy path in production (e.g. https://kataloji.com/api).
// Override with REACT_APP_API_URL at build time when the API is on a different host.
export const API_URL = process.env.REACT_APP_API_URL || `${origin}/api`;
